import {
  LOTTERY_ONE_OF_SERIAL_REQUEST,
  LOTTERY_ONE_OF_SERIAL_SUCCESS,
  LOTTERY_ONE_OF_SERIAL_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOTTERY_ONE_OF_SERIAL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LOTTERY_ONE_OF_SERIAL_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case LOTTERY_ONE_OF_SERIAL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
